import orderBy from 'lodash.orderby';

import {
  type AdvanceFilter,
  beforeAfterBetweenTypeValues,
  containsTypeValues,
  defaultFilterValues,
  matchNotMatchTypeValues,
} from '@/_containers';

import type { InvoiceBatchFilterSchema } from '../../shared/filters';

export const invoiceBatchAdvFilters: AdvanceFilter<InvoiceBatchFilterSchema>[] = orderBy(
  [
    {
      ...defaultFilterValues,
      mainKey: 'name',
      title: 'Name',
      fieldType: 'string',
      types: [...containsTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'invoices_creation_date',
      title: 'Invoice Creation Date',
      fieldType: 'date',
      types: [...beforeAfterBetweenTypeValues],
    },
    // {
    //   ...defaultFilterValues,
    //   mainKey: 'payment_date',
    //   title: 'Payment Date',
    //   fieldType: 'date',
    //   types: [...beforeAfterBetweenTypeValues],
    // },
    {
      ...defaultFilterValues,
      mainKey: 'is_paid',
      fieldType: 'radio',
      title: 'Paid',
      types: [
        {
          ...matchNotMatchTypeValues[0],
          optionValue: 'true',
          name: 'Yes',
          labelValue: 'Paid',
        },
        {
          ...matchNotMatchTypeValues[1],
          optionValue: 'false',
          name: 'No',
          labelValue: 'Not Paid',
        },
      ],
    },
    // {
    //   ...defaultFilterValues,
    //   mainKey: 'billing_period_end_date',
    //   title: fieldNames.billing_period_end_date.name,
    //   fieldType: 'date',
    //   types: [...beforeAfterBetweenTypeValues],
    // },
    // {
    //   ...defaultFilterValues,
    //   mainKey: 'status',
    //   title: fieldNames.status.name,
    //   fieldType: 'select',
    //   options: invoiceStatusOptions,
    //   types: [...matchNotMatchTypeValues],
    // },
    // {
    //   ...defaultFilterValues,
    //   mainKey: 'brand',
    //   subKey: 'name',
    //   title: fieldNames['brand'].name,
    //   fieldType: 'custom',
    //   types: [
    //     ...containsTypeValues,
    //     { ...haveDoesntHaveTypeValue[0], absoluteKey: 'brand', labelValue: 'Known ' + fieldNames['brand'].name },
    //     { ...haveDoesntHaveTypeValue[1], absoluteKey: 'brand', labelValue: 'Unknown ' + fieldNames['brand'].name },
    //   ],
    // },
    // {
    //   ...defaultFilterValues,
    //   mainKey: 'partner',
    //   subKey: 'name',
    //   title: fieldNames['partner'].name,
    //   fieldType: 'custom',
    //   types: [
    //     ...containsTypeValues,
    //     { ...haveDoesntHaveTypeValue[0], absoluteKey: 'partner', labelValue: 'Known ' + fieldNames['partner'].name },
    //     {
    //       ...haveDoesntHaveTypeValue[1],
    //       absoluteKey: 'partner',
    //       labelValue: 'Unknown ' + fieldNames['partner'].name,
    //     },
    //   ],
    // },
    // {
    //   ...defaultFilterValues,
    //   mainKey: 'client',
    //   subKey: 'name',
    //   title: 'Company',
    //   fieldType: 'string',
    //   types: [
    //     ...containsTypeValues,
    //     { ...haveDoesntHaveTypeValue[0], absoluteKey: 'client', labelValue: 'Known Company' },
    //     { ...haveDoesntHaveTypeValue[1], absoluteKey: 'client', labelValue: 'Unknown Company' },
    //   ],
    // },
    // {
    //   ...defaultFilterValues,
    //   mainKey: 'invoice_batch_id',
    //   title: fieldNames.invoice_batch_id.name,
    //   fieldType: 'number',
    //   types: [...aboveBelowRangeTypeValues],
    // },
  ],
  'title'
);
